module.exports = __webpack_public_path__ + "static/media/carousel4.ebbf5f81.png";